import { render, staticRenderFns } from "./Facturation.vue?vue&type=template&id=4808fe98&scoped=true"
import script from "./Facturation.vue?vue&type=script&lang=ts"
export * from "./Facturation.vue?vue&type=script&lang=ts"
import style0 from "./Facturation.vue?vue&type=style&index=0&id=4808fe98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4808fe98",
  null
  
)

export default component.exports